var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlide3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 273,
    viewBox: "0 0 392 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.501 79.5C321.367 79.5 324.501 82.634 324.501 86.5V105.086L338.208 118.793L340.312 120.897L337.364 120.491L324.501 118.716V142.5C324.501 146.366 321.367 149.5 317.501 149.5H173.501C169.635 149.5 166.501 146.366 166.501 142.5V86.5C166.501 82.634 169.635 79.5 173.501 79.5H317.501ZM323.001 117.5H322.501V142.5C322.501 145.261 320.262 147.5 317.501 147.5H173.501C170.74 147.5 168.501 145.261 168.501 142.5V86.5C168.501 83.7386 170.74 81.5 173.501 81.5H317.501C320.262 81.5 322.501 83.7386 322.501 86.5V105.5L322.294 105.707L322.501 105.914V106H322.587L334.69 118.103L323.138 116.509L323.001 117.5Z",
    fill: "#5b5eff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235 79.5V38C235 34.6863 232.314 32 229 32H73C69.6863 32 67 34.6863 67 38V133C67 136.314 69.6863 139 73 139H168",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58H234",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.5 101L269.5 117.5M268 122L266 126.5",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.5 101L277.5 117.5M276 122L274 126.5",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.5 101L286.5 117.5M285 122L283 126.5",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.88 228.266L116.318 234.942C111.11 239.065 94.405 222.485 97.6517 211.644C119.668 194.293 118.552 194.628 123.743 190.256L137.289 149.575C143.841 144.411 160.316 149.963 176.815 174.475C187.071 189.712 192.734 205.97 187.492 210.101L141.557 216.76L136.118 220.129M124.88 228.266L140.408 251.716C144.873 254.604 154.688 249.344 152.321 243.153C147.289 235.587 142.765 229.366 136.118 220.129M124.88 228.266L136.118 220.129",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.743 190.256L137.289 149.575C143.841 144.411 160.316 149.963 176.815 174.475C187.071 189.712 192.734 205.97 187.492 210.101L141.557 216.76L136.118 220.129C142.765 229.366 147.289 235.587 152.321 243.153C154.688 249.344 144.873 254.604 140.408 251.716L124.88 228.266L116.318 234.942C111.11 239.065 94.405 222.485 97.6517 211.644C119.668 194.293 118.552 194.628 123.743 190.256Z",
    fill: "#5b5eff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180 141.5L197 114M197 154.5L232 134.5M197 176.5L235.5 183",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M67 40C67 35.5817 70.5817 32 75 32H227C231.418 32 235 35.5817 235 40V58H67V40Z",
    fill: "#5b5eff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlide3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slide-3.306ac61e0098a565e5ec5921e20533eb.svg";